import * as types from './mutation-types'
import {UPDATE_FOLDER} from "./mutation-types";

export default {
  [types.LOAD_FOLDERS](state, data) {
    state.folders = data
  },
  [types.ADD_FOLDER](state, data) {
    state.folders.push(data)
  },

  [types.UPDATE_FOLDER](state) {
    state.folders =  state.folders.map(folder => {
      if(folder.path === 'INBOX'){
        folder.total_emails +=1
      }
      return folder
    })
  }
}
